<template>
  <div class="wl-certity-query-wrapper">
    <div class="pc-certity-query-main">
      <div
        class="head-banner-con"
        :style="{ backgroundImage: 'url(' + bannerImg + ')' }"
      >
        <div class="search-cerfity-content clearfix">
          <div class="search-form-con">
            <h1 class="cerfity-title-con">考试结果查询</h1>
            <div class="clearfix" v-if="isShowQuery">
              <el-form
                :model="ruleForm"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="name">
                  <el-input v-model="ruleForm.IDNum"></el-input>
                </el-form-item>
              </el-form>
              <div class="search-btn-con fr">
                <el-button type="primary" @click="startQuery">查询</el-button>
              </div>
            </div>
          </div>
          <div class="stu-exam-result-con" v-if="!isShowQuery">
            <el-table :data="resultData" class="result-table-con">
              <el-table-column
                prop="studentName"
                label="姓名"
              ></el-table-column>
              <el-table-column
                prop="idCard"
                label="身份证号"
                width="180"
              ></el-table-column>
              <el-table-column prop="siteName" label="考点"></el-table-column>
              <el-table-column
                prop="examTime"
                label="考试时间"
              ></el-table-column>
              <el-table-column
                prop="qualifiedState"
                label="考试结果"
              ></el-table-column>
            </el-table>
            <div class="continue-query-btn">
              <el-button type="primary" @click="continueQuery"
                >继续查询</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ph-certify-query-main" style="min-height: 300px">
      <div class="form-content">
        <h3 class="h3-title-val">考试结果查询</h3>
        <div v-if="isShowQuery">
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            label-position="left"
            size="small"
            label-width="70px"
            style="margin-top: 30px"
          >
            <el-form-item label="姓名" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="name">
              <el-input v-model="ruleForm.IDNum"></el-input>
            </el-form-item>
          </el-form>
          <div class="search-btn-con">
            <el-button type="primary" size="small" @click="startQuery"
              >查询</el-button
            >
          </div>
        </div>
        <div class="ph-stu-exam-result-con" v-if="!isShowQuery">
          <div
            v-for="(item, index) in resultData"
            :key="index"
            class="stu-result-li"
          >
            <p class="p-stu-result-con">姓名：{{ item.studentName }}</p>
            <p class="p-stu-result-con">身份证号：{{ item.idCard }}</p>
            <p class="p-stu-result-con">考点：{{ item.siteName }}</p>
            <p class="p-stu-result-con">考试时间：{{ item.examTime }}</p>
            <p class="p-stu-result-con">考试结果：{{ item.qualifiedState }}</p>
          </div>
          <div class="ph-continue-query-btn">
            <el-button type="primary" size="small" @click="continueQuery"
              >继续查询</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MU_UPATE_AUTH } from "store/index";
import redirect from "api/v1.commom.login.ts";
import CryptoJS from "crypto-js";
export default {
  created() {
  },
  data() {
    return {
      stuName: "",
      stuNumber: "",
      stuCover: "",
      show: 0,
      // 登录
      isShow: false,
      bannerImg: require("assets/images/certify-banner-img.png"),
      modelCerfity: require("assets/images/cerfity-model.png"),
      ruleForm: {
        name: "",
        IDNum: "",
      },
      gradeForm: {
        name: "",
        IDNum: "",
      },
      gradeVisible: false,
      cerfityVisible: false,
      activeIndex: 1,
      isShowQuery: true,
      resultData: [],
    };
  },
  computed: {
    association: function () {
      return this.$store.state.association;
    },
    userInfo() {
      return this.$store.state.auth;
    },
  },
  methods: {
    goHome() {
      this.$router.push({
        name: "xHome",
      });
    },
    startQuery() {
      if (this.ruleForm.name == "") {
        return this.$message.warning("请输入姓名!");
      }
      if (this.ruleForm.IDNum == "") {
        return this.$message.warning("请输入身份证号!");
      }
      this.$http
        .post("/api/XOrg/ResultsManager/getStudentResultInfo", {
          studentName: this.ruleForm.name,
          idCard: this.ruleForm.IDNum,
        })
        .then((res) => {
          if (res.code > 0) {
            this.resultData = res.list;
            this.isShowQuery = false;
          } else {
            return this.$message.warning("未查询到结果!");
          }
        });
    },
    continueQuery() {
      this.isShowQuery = true;
      this.ruleForm.name = "";
      this.ruleForm.IDNum = "";
    },
  },
};
</script>
